import React from "react"
import { FaMobileAlt, FaEnvelope, FaTwitter, FaFacebookF, FaInstagram } from "react-icons/fa"

const Contact = () => {
  return (
    <section className="contact-section bg-green" id='contact'>
      <div className="container">
        <div className="row d-flex justify-content-center">
          <div className="col-md-4 mb-3 mb-md-0">
            <div className="card py-4 h-100">
              <div className="card-body text-center">
                <FaEnvelope className='text-primary mb-2' />
                <h4 className="text-uppercase m-0">Email</h4>
                <hr className="my-4" />
                <div className="small text-black-50"><a
                  href="mailto:safepassageforwildlife@zohomail.com?subject=Enquiry">safepassageforwildlife@zohomail.com</a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-3 mb-md-0">
            <div className="card py-4 h-100">
              <div className="card-body text-center">
                <FaMobileAlt className='text-primary mb-2' />
                <h4 className="text-uppercase m-0">Phone</h4>
                <hr className="my-4" />
                <div className="small text-black-50"><a href="tel:07852 139796">07852 139796</a></div>
              </div>
            </div>
          </div>
        </div>
        <div className="social d-flex justify-content-center">
          <a aria-label='twitter' className="mx-2 mb-5" href="https://www.twitter.com/spfwcampaign/" target="_blank"
             rel="noopener noreferrer"><FaTwitter /></a>
          <a aria-label='facebook' className="mx-2" href="https://www.facebook.com/spfwcampaign/" target="_blank"
             rel="noopener noreferrer"><FaFacebookF /></a>
          <a aria-label='instagram' className="mx-2"
             href="https://www.instagram.com/safe_passage_for_wildlife/" target="_blank"
             rel="noopener noreferrer"><FaInstagram /></a>
        </div>
      </div>
    </section>
  )
}

export default Contact
